export const handleSort = (
  sortedColumn: String | null,
  sortedDirection: String | null,
  dispatch: any,
  sortingFunction: Function,
  field?: String
) => {
  if (field === sortedColumn) {
    const direction =
      sortedDirection === "ASC"
        ? "DESC"
        : sortedDirection === "DESC"
        ? null
        : "ASC";

    if (direction) {
      dispatch(
        sortingFunction({
          sortedColumn: field,
          sorting: `${field},${direction}`,
          sortedDirection: direction,
        })
      );
    } else {
      dispatch(
        sortingFunction({
          sortedColumn: null,
          sorting: null,
          sortedDirection: null,
        })
      );
    }
  } else {
    dispatch(
      sortingFunction({
        sortedColumn: field,
        sorting: `${field},ASC`,
        sortedDirection: "ASC",
      })
    );
  }
};
